import { Avatar, Badge } from "@mui/material";
import Icons from "../../../resources/icons/Icons";
import { UserCircle as UserCircleIcon } from "../../../resources/icons/user-circle";
import classes from "./RoundImage.module.css";

const RoundImage = (props) => {
  return (
    <div className={classes.roundImage}>
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        badgeContent={
          props.hasAppBadge && <img alt="App icon" src={Icons.APP} />
        }
      >
        <Avatar
          className={`${props.isRow ? classes.rowAvatar : classes.avatar} ${classes[props.sizeClass]}`}
          src={props.image}
        >
          <UserCircleIcon fontSize="small" />
        </Avatar>
      </Badge>

    </div>
  );
};

export default RoundImage;
